export const GET_TASK_REQUEST = 'GET_TASK_REQUEST';
export const GET_TASKS_REQUEST = 'GET_TASKS_REQUEST';
export const SET_TASK_DATA_REQUEST = 'SET_TASK_DATA_REQUEST';
export const SET_TASK_RESPONSIBLE_REQUEST = 'SET_TASK_RESPONSIBLE_REQUEST';
export const SET_TASK_ASSIGNEES_REQUEST = 'SET_TASK_ASSIGNEES_REQUEST';
export const CREATE_TASK_REQUEST = 'CREATE_TASK_REQUEST';
export const UPDATE_TASK_STATUS_REQUEST = 'UPDATE_TASK_STATUS_REQUEST';
export const DELETE_TASK_ASSIGNEE_REQUEST = 'DELETE_TASK_ASSIGNEE_REQUEST';
export const COMPLETE_TASK_REQUEST = 'COMPLETE_TASK_REQUEST';
export const DELETE_TASK_REQUEST = 'DELETE_TASK_REQUEST';
export const RESTORE_TASK_REQUEST = 'RESTORE_TASK_REQUEST';
export const GET_TASKS_BY_USER_REQUEST = 'GET_TASKS_BY_USER_REQUEST';
export const GET_SUGGESTED_DUE_DATE_REQUEST = 'GET_SUGGESTED_DUE_DATE_REQUEST';
export const TOGGLE_TASK_BOARD_REQUEST = 'TOGGLE_TASK_BOARD_REQUEST';
export const GET_BOARD_CARDS_REQUEST = 'GET_BOARD_CARDS_REQUEST';
export const ADD_BOARD_CARD_REQUEST = 'ADD_BOARD_CARD_REQUEST';
export const UPDATE_BOARD_CARD_REQUEST = 'UPDATE_BOARD_CARD_REQUEST';
export const MOVE_BOARD_CARD_COLUMN_REQUEST = 'MOVE_BOARD_CARD_COLUMN_REQUEST';
export const REMOVE_BOARD_CARD_REQUEST = 'REMOVE_BOARD_CARD_REQUEST';
export const UPDATE_BOARD_COLUMNS_REQUEST = 'UPDATE_BOARD_COLUMNS_REQUEST';
export const ATTACH_BOARD_CARD_ATTACHMENTS_REQUEST = 'ATTACH_BOARD_CARD_ATTACHMENTS_REQUEST';
export const DETACH_BOARD_CARD_ATTACHMENT_REQUEST = 'DETACH_BOARD_CARD_ATTACHMENT_REQUEST';
export const RETRY_BOARD_CARD_PUSH_REQUEST = 'RETRY_BOARD_CARD_PUSH_REQUEST';
export const ADD_CHECKLIST_ITEM_REQUEST = 'ADD_CHECKLIST_ITEM_REQUEST';
export const RENAME_CHECKLIST_ITEM_REQUEST = 'RENAME_CHECKLIST_ITEM_REQUEST';
export const REMOVE_CHECKLIST_ITEM_REQUEST = 'REMOVE_CHECKLIST_ITEM_REQUEST';
export const TOGGLE_CHECKLIST_ITEM_REQUEST = 'TOGGLE_CHECKLIST_ITEM_REQUEST';
export const IMPORT_TASK_CHECKLIST_REQUEST = 'IMPORT_TASK_CHECKLIST_REQUEST';
export const UPDATE_TASK_BLOCKERS_REQUEST = 'UPDATE_TASK_BLOCKERS_REQUEST';
export const COMPLETE_TASK_WITH_BYPASS_REQUEST = 'COMPLETE_TASK_WITH_BYPASS_REQUEST';
export const UPDATE_TASK_STATUS_WITH_BYPASS_REQUEST = 'UPDATE_TASK_STATUS_WITH_BYPASS_REQUEST';

export const getTask = (taskId, callback) => ({
    type: GET_TASK_REQUEST,
    payload: { taskId, callback }
});

export const getTasks = (start, limit, callback) => ({
    type: GET_TASKS_REQUEST,
    payload: { start, limit, callback },
});

export const getTasksByUser = (userId, callback) => ({
    type: GET_TASKS_BY_USER_REQUEST,
    payload: { userId, callback },
});

export const setUpdateTask = (taskId, taskData, callback) => ({
    type: SET_TASK_DATA_REQUEST,
    payload: { taskId, taskData, callback },
});

export const setTaskResponsible = (taskId, responsible, callback) => ({
    type: SET_TASK_RESPONSIBLE_REQUEST,
    payload: { taskId, responsible, callback },
});

export const setTaskAssignees = (taskId, assignees, callback) => ({
    type: SET_TASK_ASSIGNEES_REQUEST,
    payload: { taskId, assignees, callback },
});

export const createTask = (taskData, callback) => ({
    type: CREATE_TASK_REQUEST,
    payload: { taskData, callback },
});

export const updateTaskStatus = (taskId, status, callback, onGateBlocked) => ({
    type: UPDATE_TASK_STATUS_REQUEST,
    payload: { taskId, status, callback, onGateBlocked },
});

export const updateTaskStatusWithBypass = (taskId, status, callback, onGateBlocked) => ({
    type: UPDATE_TASK_STATUS_WITH_BYPASS_REQUEST,
    payload: { taskId, status, callback, onGateBlocked },
});

export const deleteTaskAssignee = (taskId, assignees, callback) => ({
    type: DELETE_TASK_ASSIGNEE_REQUEST,
    payload: { taskId, assignees, callback },
});

export const completeTask = (taskId, callback, onGateBlocked) => ({
    type: COMPLETE_TASK_REQUEST,
    payload: { taskId, callback, onGateBlocked },
});

export const completeTaskWithBypass = (taskId, callback, onGateBlocked) => ({
    type: COMPLETE_TASK_WITH_BYPASS_REQUEST,
    payload: { taskId, callback, onGateBlocked },
});

export const toggleTaskBoard = (taskId, hasBoard, callback) => ({
    type: TOGGLE_TASK_BOARD_REQUEST,
    payload: { taskId, hasBoard, callback },
});

export const getBoardCards = (taskId, callback) => ({
    type: GET_BOARD_CARDS_REQUEST,
    payload: { taskId, callback },
});

export const addBoardCard = (taskId, payload, callback) => ({
    type: ADD_BOARD_CARD_REQUEST,
    payload: { taskId, payload, callback },
});

export const updateBoardCard = (taskId, cardId, fields, callback) => ({
    type: UPDATE_BOARD_CARD_REQUEST,
    payload: { taskId, cardId, fields, callback },
});

export const moveBoardCardColumn = (taskId, cardId, columnId, callback) => ({
    type: MOVE_BOARD_CARD_COLUMN_REQUEST,
    payload: { taskId, cardId, columnId, callback },
});

export const removeBoardCard = (taskId, cardId, callback) => ({
    type: REMOVE_BOARD_CARD_REQUEST,
    payload: { taskId, cardId, callback },
});

export const updateBoardColumns = (taskId, columns, baseColumns, callback) => ({
    type: UPDATE_BOARD_COLUMNS_REQUEST,
    payload: { taskId, columns, baseColumns, callback },
});

export const attachBoardCardAttachments = (taskId, cardId, payload, callback) => ({
    type: ATTACH_BOARD_CARD_ATTACHMENTS_REQUEST,
    payload: { taskId, cardId, payload, callback },
});

export const detachBoardCardAttachment = (taskId, cardId, attachmentId, callback) => ({
    type: DETACH_BOARD_CARD_ATTACHMENT_REQUEST,
    payload: { taskId, cardId, attachmentId, callback },
});

export const retryBoardCardPush = (taskId, cardId, payload, callback) => ({
    type: RETRY_BOARD_CARD_PUSH_REQUEST,
    payload: { taskId, cardId, payload, callback },
});

export const addChecklistItem = (taskId, payload, callback) => ({
    type: ADD_CHECKLIST_ITEM_REQUEST,
    payload: { taskId, payload, callback },
});

export const renameChecklistItem = (taskId, itemId, name, callback) => ({
    type: RENAME_CHECKLIST_ITEM_REQUEST,
    payload: { taskId, itemId, name, callback },
});

export const removeChecklistItem = (taskId, itemId, callback) => ({
    type: REMOVE_CHECKLIST_ITEM_REQUEST,
    payload: { taskId, itemId, callback },
});

export const toggleChecklistItem = (taskId, itemId, completed, callback) => ({
    type: TOGGLE_CHECKLIST_ITEM_REQUEST,
    payload: { taskId, itemId, completed, callback },
});

export const importTaskChecklist = (taskId, checklistTemplateId, callback) => ({
    type: IMPORT_TASK_CHECKLIST_REQUEST,
    payload: { taskId, checklistTemplateId, callback },
});

export const updateTaskBlockers = (taskId, add, remove, callback) => ({
    type: UPDATE_TASK_BLOCKERS_REQUEST,
    payload: { taskId, add, remove, callback },
});

export const deleteTask = (taskId, callback) => ({
    type: DELETE_TASK_REQUEST,
    payload: { taskId, callback },
});

export const restoreTask = (taskId, callback) => ({
    type: RESTORE_TASK_REQUEST,
    payload: { taskId, callback },
});

export const getSuggestedDueDate = (project, responsible, hours, callback) => ({
    type: GET_SUGGESTED_DUE_DATE_REQUEST,
    payload: { project, responsible, hours, callback },
});
